import ACTION_CONSTANTS from "./action_constants";
import { CartItemResource } from "./resources";

const MAX_TOBACCO_QUANTITY = 10;

export default class ActionSource {
	constructor({ dispatch, states }) {
		this.dispatch = dispatch;
		this.states = states;
	}

	setLocale = (data) => {
		this.dispatch({ type: ACTION_CONSTANTS.CHANGE_LOCALE, payload: data });
	};

	setTheme = (data) => {
		this.dispatch({ type: ACTION_CONSTANTS.CHANGE_THEME, payload: data });
	};

	clearCache = () => {
		this.dispatch({ type: ACTION_CONSTANTS.CLEAR_CACHE });
	};

	updateCart = (props) => {
		// console.log(props);
		const { type = "add", product_id = null, item = {}, quantity = 1 } = props;
		if (!["add", "sub", "remove"].includes(type)) {
			return;
		}
		const productId = product_id || item.uid || item.product_id;
		if (!productId) {
			return;
		}
		const cartItems = [...this.states.cartItems];
		// console.log(cartItems);

		const removeItem = () => {
			const ItemIndex = cartItems.findIndex((i) => i.id === productId);
			cartItems.splice(ItemIndex, 1);
		};

		if (["add", "sub"].includes(type)) {
			// console.log(cartItems, CartItemResource(item));
			const itemExists = cartItems.some((i) => i.id === productId);
			if (itemExists) {
				// Already exists
				const ItemIndex = cartItems.findIndex((i) => i.id === productId);
				if (type == "add") {
					const itemExists = cartItems.some((i) => {
						// console.log(i);
						if (i.product_family && ["vuse-epod-2-starters-offer"].includes(i.product_family) && i.id === productId) {
							return true;
						}
						if (["3a6c8418537d", "c63cfbf4831f"].includes(i.id) && i.quantity > 4) {
							return true;
						}
						if (
							i.product_family &&
							["vuse-epod-2", "vuse-epod-2-flavor"].includes(i.product_family) &&
							i.id === productId &&
							quantity + i.quantity > 10
						) {
							return true;
						}
						if (
							i.main_category &&
							["B&H", "John Player", "Alchemy Series", "Lucky Strike"].includes(i.main_category) &&
							i.id === productId &&
							quantity + i.quantity > MAX_TOBACCO_QUANTITY
						) {
							return true;
						}
						if (
							i.main_category &&
							["d84f32c139c6", "02da16f1cb75", "46b479253b02", "0a4f7be0b928", "c321d39a2fc7", "689fccba2d4c"].includes(i.id) &&
							i.id === productId &&
							quantity + i.quantity > 3
						) {
							return true;
						}

						if (i.id === productId && i.max_quantity_per_order && quantity + i.quantity > i.max_quantity_per_order) {
							return true;
						}

						return false;
					});
					if (!itemExists) {
						cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) + quantity;
					}
				} else {
					if (cartItems[ItemIndex]["quantity"] == 1) {
						// remove
						removeItem();
					} else {
						cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) - quantity;
					}
				}
			} else {
				// Not exist, need to add
				let newQuantity = quantity;
				if (
					item &&
					item.product_family &&
					item.product_family.slug &&
					["vuse-epod-2", "vuse-epod-2-flavor"].includes(item.product_family.slug) &&
					quantity >= 10
				) {
					newQuantity = 10;
				}
				if (item && item.main_category && ["B&H", "John Player", "Alchemy Series", "Lucky Strike"].includes(item.main_category) && quantity >= 100) {
					newQuantity = MAX_TOBACCO_QUANTITY;
				}
				// console.log(item);
				if (
					item &&
					item.uid &&
					["d84f32c139c6", "02da16f1cb75", "46b479253b02", "0a4f7be0b928", "c321d39a2fc7", "689fccba2d4c"].includes(item.uid) &&
					quantity >= 3
				) {
					newQuantity = 3;
				}

				if (item && item.max_quantity_per_order && quantity > item.max_quantity_per_order) {
					newQuantity = parseInt(item.max_quantity_per_order);
				}
				cartItems.push(CartItemResource({ ...item, ...{ quantity: newQuantity } }));
			}

			// console.log("Exists::", exists);
		} else if (type == "remove") {
			// Remove the item
			removeItem();
		}

		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: cartItems });
	};

	clearCart = () => {
		console.log("call clear cart");
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: [] });
	};

	replaceCart = (item) => {
		const newItem = CartItemResource(item);
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: [newItem] });
	};
}
